import { toast } from '@/components/toast';
import { deleteTrain } from '@/pages/avatar/api';
import { useAnalytics } from '@/services/analytics';
import { GET_PRESENTERS_KEY } from '@/state/presenters/presenters';
import { MixPanelEvent } from '@/utils/types';
import { AxiosError } from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { AvatarType, MixpanelGroupEventDelete } from '../common';
import { VALIDATE_USER_CAPPING_QUERY_KEY } from './useValidateUserCapping';

export function useDeleteTrain() {
    const mixpanel = useAnalytics();
    const queryClient = useQueryClient();

    return useMutation(deleteTrain, {
        async onSuccess() {
            await queryClient.invalidateQueries([GET_PRESENTERS_KEY]);
            await queryClient.invalidateQueries(VALIDATE_USER_CAPPING_QUERY_KEY);
            mixpanel?.track(MixpanelGroupEventDelete.Train, {
                event: MixPanelEvent.SUCCESS,
                itemType: AvatarType.PremiumPlus,
            });
        },

        onError(error: AxiosError<{ kind: string; description?: string }>) {
            const kind = error?.response?.data?.kind;
            mixpanel?.track(MixpanelGroupEventDelete.Train, {
                kind,
                event: MixPanelEvent.ERROR,
                itemType: AvatarType.PremiumPlus,
            });
            toast.error({ title: 'Failed to delete avatar, please try again', toastId: `delete-presenter-error` });
        },
    });
}
